import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { PrimaryButton } from '@shared/ui/atoms/buttons/PrimaryButton';
import { failureNotification, successNotification } from '@shared/store/notification.duck';

interface Props {
  disabled?: boolean;
  onSave?: () => Promise<void>;
}

export function SectionSaveButton(props: Props) {
  const dispatch = useDispatch();
  const [saving, setSaving] = useState(false);

  // Without an onSave handler the settings in the section persist as they
  // are changed; clicking save blurs any focused text field so its pending
  // edit is committed, then confirms to the user.
  const onSaveClicked = async () => {
    if (saving) return;
    setSaving(true);
    try {
      if (props.onSave) {
        await props.onSave();
      } else {
        await new Promise(resolve => setTimeout(resolve, 300));
      }
      dispatch(successNotification('Changes saved'));
    } catch {
      dispatch(failureNotification('Failed to save changes'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <SaveButtonRow>
      <PrimaryButton text={'button.save-changes'}
                     click={onSaveClicked}
                     disabled={!!props.disabled || saving} />
    </SaveButtonRow>
  );
}

const SaveButtonRow = styled.div`
  margin: 32px 0 48px 0;
`;
